import PropTypes from 'prop-types';

import translate from './translate';

const Translate = props => {
  const { children } = props;

  if (typeof children !== 'string') {
    return '';
  }

  return translate(children);
};

Translate.propTypes = {
  children: PropTypes.node,
};

export default Translate;

